import { MouseEvent, useRef } from 'react';

// Click-outside-to-close for a portal modal's backdrop. Spread the returned
// handlers onto the full-screen backdrop element.
//
// Dismisses only when the press both STARTS and ENDS on the backdrop itself.
// Checking the click's target alone isn't enough for a form: drag-selecting
// text in a field and releasing past the panel's edge fires `click` on the
// backdrop (the common ancestor of the press and the release), which would
// close the modal and throw away what the user typed.
//
// Both handlers also stop propagation — the modals render through a portal,
// so without it React would bubble their clicks up into whatever card or row
// opened them.
const useBackdropDismiss = (onDismiss: () => void) => {
  const pressStartedOnBackdropRef = useRef(false);

  return {
    onMouseDown: (e: MouseEvent<HTMLElement>) => {
      e.stopPropagation();
      pressStartedOnBackdropRef.current = e.target === e.currentTarget;
    },
    onClick: (e: MouseEvent<HTMLElement>) => {
      e.stopPropagation();
      const startedOnBackdrop = pressStartedOnBackdropRef.current;
      pressStartedOnBackdropRef.current = false;
      if (startedOnBackdrop && e.target === e.currentTarget) onDismiss();
    },
  };
};

export default useBackdropDismiss;
